import payment from './payment';

export default payment;
